export default "__VITE_ASSET__Bk$M4rRq__"